import { render, staticRenderFns } from "./QuestionAnswerHistory.vue?vue&type=template&id=676cc3e3&"
import script from "./QuestionAnswerHistory.vue?vue&type=script&lang=js&"
export * from "./QuestionAnswerHistory.vue?vue&type=script&lang=js&"
import style0 from "./QuestionAnswerHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('676cc3e3')) {
      api.createRecord('676cc3e3', component.options)
    } else {
      api.reload('676cc3e3', component.options)
    }
    module.hot.accept("./QuestionAnswerHistory.vue?vue&type=template&id=676cc3e3&", function () {
      api.rerender('676cc3e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/questions/QuestionAnswerHistory.vue"
export default component.exports